import DocumentManager from "Components/_PageComponents/DocumentManager/DocmentManager";
import { defaultProps } from "Components/_PageComponents/DocumentManager/defaultProps";

export default function GPTQADocumentManager() {
  return <DocumentManager {...defaultProps} />;
}
